

const completedIcon = () => {
  return (
    <div>
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="8" fill="#34C759" fill-opacity="0.1"/>
<rect x="0.5" y="0.5" width="39" height="39" rx="7.5" stroke="#34C759" stroke-opacity="0.5"/>
<path d="M13 22.5C13 22.5 14.5 22.5 16.5 26C16.5 26 22.0588 16.8333 27 15" stroke="#34C759" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    </div>
  )
}

export default completedIcon